/** Shared labels and formatting for the Data sources pages. */

export const FRESHNESS_LABEL = { fresh: 'Fresh', overdue: 'Overdue', never: 'Never synced' };
export const CADENCE_LABEL = { hourly: 'Hourly', daily: 'Daily', weekly: 'Weekly', monthly: 'Monthly', none: 'No schedule' };
export const WIDGET_TYPE_LABEL = {
  gauge: 'Gauge', count: 'Count', table: 'Table', service_status: 'Service status',
  line_chart: 'Line chart', area_chart: 'Area chart', chart: 'Chart',
};
export const ROLLUP_AGGREGATIONS = ['avg', 'max', 'min', 'sum', 'last'];
export const ROLLUP_LABEL = { avg: 'Average', max: 'Maximum', min: 'Minimum', sum: 'Total', last: 'Last value' };

export const formatDateTime = (value) => (value ? new Date(value).toLocaleString() : 'Never');
export const formatNumber = (value) => (value === null || value === undefined ? '—' : Number(value).toLocaleString());

/** The headline number a pushed metric value stands for. */
export function currentOf(value) {
  if (value === null || value === undefined) return null;
  if (Array.isArray(value)) return null;
  if (typeof value === 'object') return value.current ?? null;
  return value;
}

/** Short text for a pushed value: "47", "4 items", "—". */
export function describeValue(value) {
  const current = currentOf(value);
  if (current !== null && current !== undefined) return Number.isFinite(Number(current)) ? Number(current).toLocaleString() : String(current);
  if (Array.isArray(value)) return `${value.length} item${value.length === 1 ? '' : 's'}`;
  return '—';
}

export const datasetPath = (name) => `/admin/data-sources/datasets/${encodeURIComponent(name)}`;
export const metricPath = (key) => `/admin/data-sources/metrics/${encodeURIComponent(key)}`;
export const packPath = (id) => `/admin/data-sources/packs/${encodeURIComponent(id)}`;

/** A KPI target as typed (percent KPIs in %) to the value stored (a fraction); NaN when not a number. */
export function targetValue(kpi, typed) {
  if (typed === '' || typed === null || typed === undefined) return null;
  const n = Number(typed);
  if (!Number.isFinite(n)) return NaN;
  return kpi.format === 'percent' ? n / 100 : n;
}

/** Who defines a dataset: an installed pack (or the platform itself), or the company. */
export function definedBy(dataset) {
  if (!dataset) return '';
  if (dataset.definitionSource === 'pack') return dataset.packTitle ? `${dataset.packTitle} pack` : 'Kinspeed';
  return 'Your company';
}

/** A dataset or column name from a title: lowercase letters, digits and underscores, starting with a letter. */
export function toIdentifier(text) {
  const base = String(text || '').toLowerCase().replace(/[^a-z0-9]+/g, '_').replace(/^_+|_+$/g, '');
  if (!base) return '';
  return /^[a-z]/.test(base) ? base : `d_${base}`;
}

export const COLUMN_TYPES = [
  { value: 'string', label: 'Text' },
  { value: 'number', label: 'Number' },
  { value: 'date', label: 'Date' },
  { value: 'boolean', label: 'Yes / no' },
];
export const COLUMN_TYPE_LABEL = Object.fromEntries(COLUMN_TYPES.map((t) => [t.value, t.label]));
